import { canAdd, canView } from "../../../utils/permissionHelper";

export const Nikshay_Main_Modal = ({ onCloseNikshayMainModel, onSelect, data }) => {
    // Get permissions from localStorage

    let permissions = [];
    try {
        const storedPermissions = localStorage.getItem('NIKSHAY_Permissions');
        if (storedPermissions) {
            const parsed = JSON.parse(storedPermissions);

            // ✅ Ensure it's always an array
            permissions = Array.isArray(parsed)
                ? parsed
                : Array.isArray(parsed?.permissions)
                    ? parsed.permissions
                    : [];
        }
    } catch (error) {
        console.error('Error parsing permissions:', error);
        permissions = [];
    }

    // Check permissions for nikshay module
    const canViewPatient = canView(permissions, 'registration');
    const canAddTest = canAdd(permissions, 'add_test');

    return (
        <>
            <div className="modal fade show d-block verificationModel" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0 ">
                            <div className="text-center headerText patientDetailsTitleHeader-h d-flex">
                                <span><img src="" alt="" className='pnmdp_icon' /></span>
                                <h5 className="modal-title" id="exampleModalLabel">Ni-kshay</h5>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onCloseNikshayMainModel} />

                        </div>
                        <div className="modal-body">
                            <div className="sickCellRow row">
                                {canViewPatient && (
                                    <div className=" col-xs-12 col-md-4">
                                        <div className="sickCellCol" onClick={() => { onSelect('View Nikshay Details'); }}>
                                            <div className="circleImg">
                                                <span>
                                                    <img src={"/images/Sick/hand.png"} alt="" />
                                                </span>
                                            </div>
                                            <div className="sickColTitle">
                                                <h5>View Patient</h5>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {/* {canAddTest && (
                                    <div className="sickCellCol col-xs-12 col-md-4"
                                        onClick={() => { onSelect('Add Nikshay Test'); }}
                                    >
                                        <div className="circleImg">
                                            <span>
                                                <img src={"/images/Sick/Pencile.svg"} alt="" />
                                            </span>
                                        </div>
                                        <div className="sickColTitle">
                                            <h5>Add Test</h5>
                                        </div>
                                    </div>
                                )} */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}
export default Nikshay_Main_Modal;